import Drawer  from "./DrawerComponent";
import CustomButton from '../common/CustomButton';

interface ConfirmModalProps {
    showModal: boolean;
    setShowModal: (showModal: boolean) => void;
    handleConfirm: any;
    content: string;
    className: string;
}

const ConfirmModal = ({ setShowModal, showModal,handleConfirm, content,className }: ConfirmModalProps) => {
    const handleClose = () => {
        setShowModal(false);
    }

    return (
        <Drawer
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          position="right"
          className={className}
        >
        <div  tabIndex={-1} className="h-full  bg-white dark:bg-[#111928]">
            <div className="border-b border-gray-200 !p-6 dark:border-gray-700 bg-yellow-500">
                Warning
            </div>
            <div className='flex flex-col items-center justify-center p-10 h-full '>
                    <div className="relative ">
                        <div className="py-6 text-center max-w-[600px]">
                            {/* <svg aria-hidden="true" className="mx-auto mb-4 text-gray-400 w-14 h-14 dark:text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg> */}
                            <div className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">{content}</div>
                            <div className="flex gap-2 justify-center">
                                <CustomButton 
                                    onClick={handleConfirm} 
                                    variant="danger"
                                >
                                    Submit
                                </CustomButton>
                                <CustomButton 
                                    onClick={handleClose}  
                                    variant="cancel"
                                >
                                    No, cancel
                                </CustomButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Drawer>
    )
}

export default ConfirmModal;